const gisMap = () => import('Views/gisMap/gis-map');

export default[
  { path: '/gis-map-headFull', component: gisMap },
];



// WEBPACK FOOTER //
// ./src/router/gisMap.js